import React from 'react';
import { FaThumbsUp } from 'react-icons/fa';
import PieChart from './PieChart';
import PosteBarChart from './PosteBarChart';
import PieStatCard from './PieStatCard';

function StatsPanel({
  stats,
  submissions,
  disponibiliteStats,
  moyenDeplacementAutreStats,
}) {
  return (
    <>
            {submissions.length === 0 && (
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4">
                <p className="text-yellow-800">
                  ⚠️ Aucune candidature trouvée. Les graphiques s'afficheront une fois que des candidatures auront été soumises.
                </p>
              </div>
            )}
            <PosteBarChart stats={stats} />


            <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-6 mt-6">
              <div className="flex justify-between items-center mb-6 pb-2 border-b-2 border-blue-400">
                <h2 className="text-xl font-semibold text-gray-800">
                  Quel est votre niveau de scolarisation le plus élevé atteint ?
                </h2>
                <span className="text-sm text-gray-600">
                  {stats.scolarisationAucun + stats.scolarisationCep + stats.scolarisationBepc + 
                   stats.scolarisationCap + stats.scolarisationBac + stats.scolarisationUniversitaire} réponses
                </span>
              </div>
              <div className="flex flex-col md:flex-row gap-8 items-center">
                <div className="flex-shrink-0">
                  <PieChart
                    data={[
                      { label: 'Aucun ou Alphabetisation', value: stats.scolarisationAucun, color: '#1e3a8a' },
                      { label: 'CEP (Certificat d\'Études Primaires)', value: stats.scolarisationCep, color: '#dc2626' },
                      { label: 'BEPC (Brevet d\'Études du Premier Cycle)', value: stats.scolarisationBepc, color: '#ea580c' },
                      { label: 'CAP/CQP (Certificat d\'Aptitude Professionnelle / Certificat de Qualification Professionnelle)', value: stats.scolarisationCap, color: '#16a34a' },
                      { label: 'Baccalauréat', value: stats.scolarisationBac, color: '#9333ea' },
                      { label: 'Diplôme Universitaire (Licence, Master, etc.)', value: stats.scolarisationUniversitaire, color: '#2563eb' },
                    ]}
                    size={200}
                    showLabels={true}
                  />
                </div>
                <div className="flex-1 space-y-3">
                  {[
                    { label: 'Aucun ou Alphabetisation', value: stats.scolarisationAucun, color: '#1e3a8a' },
                    { label: 'CEP (Certificat d\'Études Primaires)', value: stats.scolarisationCep, color: '#dc2626' },
                    { label: 'BEPC (Brevet d\'Études du Premier Cycle)', value: stats.scolarisationBepc, color: '#ea580c' },
                    { label: 'CAP/CQP (Certificat d\'Aptitude Professionnelle / Certificat de Qualification Professionnelle)', value: stats.scolarisationCap, color: '#16a34a' },
                    { label: 'Baccalauréat', value: stats.scolarisationBac, color: '#9333ea' },
                    { label: 'Diplôme Universitaire (Licence, Master, etc.)', value: stats.scolarisationUniversitaire, color: '#2563eb' },
                  ].map((item, index) => {
                    return (
                      <div key={index} className="flex items-center gap-3">
                        <div className="w-4 h-4 rounded" style={{ backgroundColor: item.color }}></div>
                        <span className="text-sm text-gray-700">{item.label}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Graphique Formation Professionnelle */}
            <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-6 mt-6">
              <div className="flex justify-between items-center mb-6 pb-2 border-b-2 border-blue-400">
                <h2 className="text-xl font-semibold text-gray-800">
                  Avez-vous une formation professionnelle spécifique dans le domaine technique choisi ?
                </h2>
                <span className="text-sm text-gray-600">
                  {stats.formationDiplome + stats.formationNonDiplomante + stats.formationPratique} réponses
                </span>
              </div>
              <div className="flex flex-col md:flex-row gap-8 items-center">
                <div className="flex-shrink-0">
                  <PieChart
                    data={[
                      { label: 'Oui, j\'ai un diplôme / certificat (CAP, CQP, etc.)', value: stats.formationDiplome, color: '#2563eb' },
                      { label: 'Oui, j\'ai suivi une formation non-diplômante (atelier, apprentissage sur le tas, etc.)', value: stats.formationNonDiplomante, color: '#dc2626' },
                      { label: 'Non, mon expérience est basée sur l\'apprentissage pratique', value: stats.formationPratique, color: '#ea580c' },
                    ]}
                    size={200}
                    showLabels={true}
                  />
                </div>
                <div className="flex-1 space-y-3">
                  {[
                    { label: 'Oui, j\'ai un diplôme / certificat (CAP, CQP, etc.)', value: stats.formationDiplome, color: '#2563eb' },
                    { label: 'Oui, j\'ai suivi une formation non-diplômante (atelier, apprentissage sur le tas, etc.)', value: stats.formationNonDiplomante, color: '#dc2626' },
                    { label: 'Non, mon expérience est basée sur l\'apprentissage pratique', value: stats.formationPratique, color: '#ea580c' },
                  ].map((item, index) => {
                    return (
                      <div key={index} className="flex items-center gap-3">
                        <div className="w-4 h-4 rounded" style={{ backgroundColor: item.color }}></div>
                        <span className="text-sm text-gray-700">{item.label}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Graphique Années d'Expérience */}
            <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-6 mt-6">
              <div className="flex justify-between items-center mb-6 pb-2 border-b-2 border-blue-400">
                <h2 className="text-xl font-semibold text-gray-800">
                  Depuis combien d'années exercez-vous ce métier ou un métier similaire ?
                </h2>
                <span className="text-sm text-gray-600">
                  {stats.experienceMoins1 + stats.experience1a3 + stats.experience4a7 + 
                   stats.experience8a12 + stats.experiencePlus12} réponses
                </span>
              </div>
              <div className="flex flex-col md:flex-row gap-8 items-center">
                <div className="flex-shrink-0">
                  <PieChart
                    data={[
                      { label: 'Moins de 1 an', value: stats.experienceMoins1, color: '#2563eb' },
                      { label: '1 à 3 ans', value: stats.experience1a3, color: '#dc2626' },
                      { label: '4 à 7 ans', value: stats.experience4a7, color: '#ea580c' },
                      { label: '8 à 12 ans', value: stats.experience8a12, color: '#16a34a' },
                      { label: 'Plus de 12 ans', value: stats.experiencePlus12, color: '#9333ea' },
                    ]}
                    size={200}
                    showLabels={true}
                  />
                </div>
                <div className="flex-1 space-y-3">
                  {[
                    { label: 'Moins de 1 an', value: stats.experienceMoins1, color: '#2563eb' },
                    { label: '1 à 3 ans', value: stats.experience1a3, color: '#dc2626' },
                    { label: '4 à 7 ans', value: stats.experience4a7, color: '#ea580c' },
                    { label: '8 à 12 ans', value: stats.experience8a12, color: '#16a34a' },
                    { label: 'Plus de 12 ans', value: stats.experiencePlus12, color: '#9333ea' },
                  ].map((item, index) => {
                    return (
                      <div key={index} className="flex items-center gap-3">
                        <div className="w-4 h-4 rounded" style={{ backgroundColor: item.color }}></div>
                        <span className="text-sm text-gray-700">{item.label}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Graphique Niveau de Compétence */}
            <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-6 mt-6">
              <div className="flex justify-between items-center mb-6 pb-2 border-b-2 border-blue-400">
                <h2 className="text-xl font-semibold text-gray-800">
                  Veuillez évaluer votre niveau de compétence pratique dans le domaine choisi :
                </h2>
                <span className="text-sm text-gray-600">
                  {stats.competence0 + stats.competence1 + stats.competence2 + stats.competence3 + 
                   stats.competence4 + stats.competence5 + stats.competence6 + stats.competence7 + 
                   stats.competence8 + stats.competence9 + stats.competence10} réponses
                </span>
              </div>
              <div className="space-y-4">
                {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((level) => {
                  const count = stats[`competence${level}`] || 0;
                  const total = stats.competence0 + stats.competence1 + stats.competence2 + stats.competence3 + 
                                stats.competence4 + stats.competence5 + stats.competence6 + stats.competence7 + 
                                stats.competence8 + stats.competence9 + stats.competence10;
                  const percentage = total > 0 ? ((count / total) * 100).toFixed(1) : 0;
                  const maxCount = Math.max(
                    stats.competence0 || 0, stats.competence1 || 0, stats.competence2 || 0,
                    stats.competence3 || 0, stats.competence4 || 0, stats.competence5 || 0,
                    stats.competence6 || 0, stats.competence7 || 0, stats.competence8 || 0,
                    stats.competence9 || 0, stats.competence10 || 0, 1
                  );
                  const barWidth = maxCount > 0 ? (count / maxCount * 100) : 0;
                  
                  // Déterminer le label selon le niveau
                  const getLabel = (lvl) => {
                    if (lvl === 0) return 'Débutant/Peu expérimenté';
                    if (lvl >= 1 && lvl <= 10) return 'Expert/Très compétent';
                    return `Niveau ${lvl}`;
                  };
                  
                  return (
                    <div key={level} className="flex items-center gap-4">
                      <div className="w-32 text-sm font-medium text-gray-700 text-right">
                        {level === 0 ? '0' : level === 1 ? '1' : level === 2 ? '2' : level === 3 ? '3' : 
                         level === 4 ? '4' : level === 5 ? '5' : level === 6 ? '6' : level === 7 ? '7' : 
                         level === 8 ? '8' : level === 9 ? '9' : '10'}
                      </div>
                      <div className="flex-1">
                        <div className="relative w-full bg-gray-100 rounded-full h-10 overflow-hidden">
                          <div
                            className="bg-gradient-to-r from-blue-500 to-blue-600 h-10 rounded-full transition-all duration-500 flex items-center justify-end pr-4 shadow-sm"
                            style={{ width: `${barWidth}%`, minWidth: count > 0 ? '80px' : '0' }}
                          >
                            {count > 0 && (
                              <span className="text-white text-sm font-semibold">
                                {count} ({percentage}%)
                              </span>
                            )}
                          </div>
                          {count === 0 && (
                            <span className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs">
                              0 (0%)
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="w-48 text-xs text-gray-600">
                        {getLabel(level)}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Graphique Lecture de Plans */}
            <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-6 mt-6">
              <div className="flex justify-between items-center mb-6 pb-2 border-b-2 border-blue-400">
                <h2 className="text-xl font-semibold text-gray-800">
                  Êtes-vous capable de lire et d'interpréter des plans ou des schémas techniques simples liés à votre métier ?
                </h2>
                <span className="text-sm text-gray-600">
                  {stats.lectureOuiSansProbleme + stats.lectureOuiAide + stats.lectureNon} réponses
                </span>
              </div>
              <div className="flex flex-col md:flex-row gap-8 items-center">
                <div className="flex-shrink-0">
                  <PieChart
                    data={[
                      { label: 'Oui, sans problème', value: stats.lectureOuiSansProbleme || 0, color: '#2563eb' },
                      { label: 'Oui, avec un peu d\'aide/difficulté', value: stats.lectureOuiAide || 0, color: '#dc2626' },
                      { label: 'Non, pas du tout', value: stats.lectureNon || 0, color: '#ea580c' },
                    ]}
                    size={200}
                    showLabels={true}
                  />
                </div>
                <div className="flex-1 space-y-2">
                  {[
                    { label: 'Oui, sans problème', value: stats.lectureOuiSansProbleme, color: '#2563eb' },
                    { label: 'Oui, avec un peu d\'aide/difficulté', value: stats.lectureOuiAide, color: '#dc2626' },
                    { label: 'Non, pas du tout', value: stats.lectureNon, color: '#ea580c' },
                  ].map((item, index) => {
                    const total = stats.lectureOuiSansProbleme + stats.lectureOuiAide + stats.lectureNon;
                    const percentage = total > 0 ? ((item.value / total) * 100).toFixed(1) : 0;
                    return (
                      <div key={index} className="flex items-center gap-3">
                        <div className="w-3 h-3 rounded-full" style={{ backgroundColor: item.color }}></div>
                        <span className="text-sm text-gray-700 flex-1">{item.label}</span>
                        <span className="text-sm text-gray-600">{percentage}%</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Graphique Capacité Instructions */}
            <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-6 mt-6">
              <div className="flex justify-between items-center mb-6 pb-2 border-b-2 border-blue-400">
                <h2 className="text-xl font-semibold text-gray-800">
                  Évaluez votre capacité à suivre des instructions écrites et orales pour l'exécution d'un travail :
                </h2>
                <span className="text-sm text-gray-600">
                  {stats.instructions1 + stats.instructions2 + stats.instructions3 + stats.instructions4 + 
                   stats.instructions5 + stats.instructions6 + stats.instructions7 + stats.instructions8 + 
                   stats.instructions9 + stats.instructions10} réponses
                </span>
              </div>
              
              {/* Section Note Moyenne avec Thumbs-up */}
              <div className="mb-8 text-center">
                <div className="text-lg font-bold text-gray-800 mb-4">
                  Note moyenne ({
                    (() => {
                      const total = stats.instructions1 + stats.instructions2 + stats.instructions3 + 
                                   stats.instructions4 + stats.instructions5 + stats.instructions6 + 
                                   stats.instructions7 + stats.instructions8 + stats.instructions9 + stats.instructions10;
                      const sum = stats.instructions1 * 1 + stats.instructions2 * 2 + stats.instructions3 * 3 + 
                                 stats.instructions4 * 4 + stats.instructions5 * 5 + stats.instructions6 * 6 + 
                                 stats.instructions7 * 7 + stats.instructions8 * 8 + stats.instructions9 * 9 + stats.instructions10 * 10;
                      return total > 0 ? (sum / total).toFixed(2) : '0.00';
                    })()
                  })
                </div>
                <div className="flex justify-center items-center gap-6">
                  {[1, 2, 3].map((num) => (
                    <div key={num} className="flex flex-col items-center">
                      <span className="text-sm font-medium text-gray-700 mb-1">{num}</span>
                      <FaThumbsUp className="text-3xl text-blue-600" />
                    </div>
                  ))}
                </div>
              </div>

              {/* Graphique en Barres Verticales */}
              <div className="mt-8">
                <div className="flex items-end justify-center gap-4 h-48 relative">
                  {/* Grille de fond */}
                  <div className="absolute inset-0 flex flex-col justify-between border-l border-b border-gray-300">
                    {[0, 20, 40, 60, 80, 100].map((val) => (
                      <div key={val} className="relative border-t border-gray-200">
                        <span className="absolute -left-8 -top-2 text-xs text-gray-600">{val}</span>
                      </div>
                    ))}
                  </div>
                  
                  {/* Barres */}
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((level) => {
                    const count = stats[`instructions${level}`] || 0;
                    const total = stats.instructions1 + stats.instructions2 + stats.instructions3 + stats.instructions4 + 
                                  stats.instructions5 + stats.instructions6 + stats.instructions7 + stats.instructions8 + 
                                  stats.instructions9 + stats.instructions10;
                    const percentage = total > 0 ? ((count / total) * 100).toFixed(1) : 0;
                    const maxCount = Math.max(
                      stats.instructions1 || 0, stats.instructions2 || 0, stats.instructions3 || 0,
                      stats.instructions4 || 0, stats.instructions5 || 0, stats.instructions6 || 0,
                      stats.instructions7 || 0, stats.instructions8 || 0, stats.instructions9 || 0,
                      stats.instructions10 || 0, 1
                    );
                    const barHeight = maxCount > 0 ? (count / maxCount * 100) : 0;
                    
                    return (
                      <div key={level} className="flex flex-col items-center relative z-10 flex-1">
                        {/* Label au-dessus de la barre */}
                        <div className="mb-2 text-center">
                          <div className="text-xs font-semibold text-gray-800">
                            {count} ({percentage}%)
                          </div>
                        </div>
                        
                        {/* Barre */}
                        <div className="relative w-full flex items-end justify-center" style={{ height: '150px' }}>
                          <div
                            className="bg-gradient-to-t from-blue-600 to-blue-500 rounded-t transition-all duration-500 shadow-md hover:shadow-lg"
                            style={{ 
                              height: `${barHeight}%`, 
                              minHeight: count > 0 ? '4px' : '0',
                              width: '16px',
                              maxWidth: '16px'
                            }}
                          ></div>
                        </div>
                        
                        {/* Label en bas */}
                        <div className="mt-2 text-xs font-medium text-gray-700">
                          {level}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Graphique Matériel de Travail */}
            <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-6 mt-6">
              <div className="flex justify-between items-center mb-6 pb-2 border-b-2 border-blue-400">
                <h2 className="text-xl font-semibold text-gray-800">
                  Avez-vous votre propre matériel de travail de base (outils principaux) ?
                </h2>
                <span className="text-sm text-gray-600">
                  {stats.materielBienEquipe + stats.materielMinimum + stats.materielNon} réponses
                </span>
              </div>
              <div className="flex flex-col md:flex-row gap-8 items-center">
                <div className="flex-shrink-0">
                  <PieChart
                    data={[
                      { label: 'Oui, je suis bien équipé', value: stats.materielBienEquipe || 0, color: '#2563eb' },
                      { label: 'Oui, j\'ai le minimum', value: stats.materielMinimum || 0, color: '#dc2626' },
                      { label: 'Non, je n\'ai pas d\'outils', value: stats.materielNon || 0, color: '#ea580c' },
                    ]}
                    size={200}
                    showLabels={true}
                  />
                </div>
                <div className="flex-1 space-y-3">
                  {[
                    { label: 'Oui, je suis bien équipé', value: stats.materielBienEquipe, color: '#2563eb' },
                    { label: 'Oui, j\'ai le minimum', value: stats.materielMinimum, color: '#dc2626' },
                    { label: 'Non, je n\'ai pas d\'outils', value: stats.materielNon, color: '#ea580c' },
                  ].map((item, index) => {
                    return (
                      <div key={index} className="flex items-center gap-3">
                        <div className="w-4 h-4 rounded" style={{ backgroundColor: item.color }}></div>
                        <span className="text-sm text-gray-700">{item.label}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Graphique Disponibilité */}
            <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-8 mt-6">
              <div className="flex justify-between items-center mb-6 pb-2 border-b-2 border-blue-400">
                <h2 className="text-xl font-semibold text-gray-800">
                  Disponibilité pour commencer le travail (en jours après l'entretien) :
                </h2>
                <span className="text-sm text-gray-600">
                  {disponibiliteStats.reduce((sum, item) => sum + item.count, 0)} réponses
                </span>
              </div>
              {disponibiliteStats.length > 0 ? (
                <div className="mt-8">
                  <div className="flex items-end justify-start gap-3 h-96 relative overflow-x-auto">
                    {/* Grille de fond */}
                    <div className="absolute inset-0 flex flex-col justify-between border-l border-b border-gray-300">
                      {[0, 20, 40, 60, 80, 100].map((val) => (
                        <div key={val} className="relative border-t border-gray-200">
                          <span className="absolute -left-10 -top-2 text-xs text-gray-600">{val}</span>
                        </div>
                      ))}
                    </div>
                    
                    {/* Barres */}
                    {disponibiliteStats.map((item, index) => {
                      const total = disponibiliteStats.reduce((sum, i) => sum + i.count, 0);
                      const percentage = total > 0 ? ((item.count / total) * 100).toFixed(1) : 0;
                      const maxCount = Math.max(...disponibiliteStats.map(i => i.count), 1);
                      const barHeight = maxCount > 0 ? (item.count / maxCount * 100) : 0;
                      
                      return (
                        <div key={index} className="flex flex-col items-center relative z-10" style={{ minWidth: '90px' }}>
                          {/* Label au-dessus de la barre */}
                          <div className="mb-2 text-center">
                            <div className="text-xs font-semibold text-gray-800">
                              {item.count} ({percentage}%)
                            </div>
                          </div>
                          
                          {/* Barre */}
                          <div className="relative w-full flex items-end justify-center" style={{ height: '300px' }}>
                            <div
                              className="bg-gradient-to-t from-blue-600 to-blue-500 rounded-t transition-all duration-500 shadow-md hover:shadow-lg"
                              style={{ 
                                height: `${barHeight}%`, 
                                minHeight: item.count > 0 ? '4px' : '0',
                                width: '20px',
                                maxWidth: '20px'
                              }}
                            ></div>
                          </div>
                          
                          {/* Label en bas */}
                          <div className="mt-2 text-xs font-medium text-gray-700 text-center px-1" style={{ maxWidth: '90px' }} title={item.label}>
                            {item.label.length > 15 ? `${item.label.substring(0, 15)}...` : item.label}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <div className="text-center py-8 text-gray-500">
                  Aucune donnée de disponibilité disponible
                </div>
              )}
            </div>

             {/* Graphique Smartphone */}
             <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-6 mt-6">
               <div className="flex justify-between items-center mb-6 pb-2 border-b-2 border-blue-400">
                 <h2 className="text-xl font-semibold text-gray-800">
                   Disposez-vous d'un Smartphone fonctionnel (Android ou iOS) ?
                 </h2>
                 <span className="text-sm text-gray-600">
                   {stats.smartphoneOui + stats.smartphoneNon} réponses
                 </span>
               </div>
               <div className="flex flex-col md:flex-row gap-8 items-center">
                 <div className="flex-shrink-0">
                   <PieChart
                     data={[
                       { label: 'oui', value: stats.smartphoneOui || 0, color: '#2563eb' },
                       { label: 'Non', value: stats.smartphoneNon || 0, color: '#ea580c' },
                     ]}
                     size={200}
                     showLabels={true}
                   />
                 </div>
                 <div className="flex-1 space-y-3">
                   {[
                     { label: 'oui', value: stats.smartphoneOui, color: '#2563eb' },
                     { label: 'Non', value: stats.smartphoneNon, color: '#ea580c' },
                   ].map((item, index) => {
                     return (
                       <div key={index} className="flex items-center gap-3">
                         <div className="w-4 h-4 rounded-full" style={{ backgroundColor: item.color }}></div>
                         <span className="text-sm text-gray-700">{item.label}</span>
                       </div>
                     );
                   })}
                 </div>
               </div>
             </div>

            {/* Graphique Accès Internet Mobile */}
            <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-6 mt-6">
              <div className="flex justify-between items-center mb-6 pb-2 border-b-2 border-blue-400">
                <h2 className="text-xl font-semibold text-gray-800">
                  Avez-vous un accès Internet Mobile régulier ?
                </h2>
                <span className="text-sm text-gray-600">
                  {stats.internetOui + stats.internetNon} réponses
                </span>
              </div>
              <div className="flex flex-col md:flex-row gap-8 items-center">
                <div className="flex-shrink-0">
                  <PieChart
                    data={[
                      { label: 'oui', value: stats.internetOui || 0, color: '#2563eb' },
                      { label: 'Non', value: stats.internetNon || 0, color: '#ea580c' },
                    ]}
                    size={200}
                    showLabels={true}
                  />
                </div>
                <div className="flex-1 space-y-3">
                  {[
                    { label: 'oui', value: stats.internetOui, color: '#2563eb' },
                    { label: 'Non', value: stats.internetNon, color: '#dc2626' },
                  ].map((item, index) => {
                    return (
                      <div key={index} className="flex items-center gap-3">
                        <div className="w-4 h-4 rounded" style={{ backgroundColor: item.color }}></div>
                        <span className="text-sm text-gray-700">{item.label}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Graphique Moyen de Déplacement */}
            <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-6 mt-6">
              <div className="flex justify-between items-center mb-6 pb-2 border-b-2 border-blue-400">
                <h2 className="text-xl font-semibold text-gray-800">
                  Moyen de Déplacement principal pour les interventions
                </h2>
                <span className="text-sm text-gray-600">
                  {stats.deplacementMoto + stats.deplacementVelo + stats.deplacementTransportPublic + stats.deplacementAutre} réponses
                </span>
              </div>
              <div className="flex flex-col md:flex-row gap-8 items-center">
                <div className="flex-shrink-0">
                  <PieChart
                    data={[
                      { label: 'Moto', value: stats.deplacementMoto, color: '#1e3a8a' },
                      { label: 'Vélo', value: stats.deplacementVelo, color: '#dc2626' },
                      { label: 'Transport public', value: stats.deplacementTransportPublic, color: '#ea580c' },
                      ...(moyenDeplacementAutreStats.length > 0 ? moyenDeplacementAutreStats.map((item, idx) => ({
                        label: item.label,
                        value: item.count,
                        color: idx === 0 ? '#16a34a' : ['#9333ea', '#f59e0b', '#06b6d4'][idx % 3]
                      })) : stats.deplacementAutre > 0 ? [{ label: 'Autre', value: stats.deplacementAutre, color: '#16a34a' }] : []),
                    ]}
                    size={200}
                    showLabels={true}
                  />
                </div>
                <div className="flex-1 space-y-3">
                  {[
                    { label: 'Moto', value: stats.deplacementMoto, color: '#1e3a8a' },
                    { label: 'Vélo', value: stats.deplacementVelo, color: '#dc2626' },
                    { label: 'Transport public', value: stats.deplacementTransportPublic, color: '#ea580c' },
                    ...(moyenDeplacementAutreStats.length > 0 ? moyenDeplacementAutreStats.map((item, idx) => ({
                      label: item.label,
                      value: item.count,
                      color: idx === 0 ? '#16a34a' : ['#9333ea', '#f59e0b', '#06b6d4'][idx % 3]
                    })) : stats.deplacementAutre > 0 ? [{ label: 'Autre', value: stats.deplacementAutre, color: '#16a34a' }] : []),
                  ].map((item, index) => {
                    return (
                      <div key={index} className="flex items-center gap-3">
                        <div className="w-4 h-4 rounded" style={{ backgroundColor: item.color }}></div>
                        <span className="text-sm text-gray-700">{item.label}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Graphique Disponibilité Préférence */}
            <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-6 mt-6">
              <div className="flex justify-between items-center mb-6 pb-2 border-b-2 border-blue-400">
                <h2 className="text-xl font-semibold text-gray-800">
                  Disponibilité : Préférence de jours/heures (Cocher)
                </h2>
                <span className="text-sm text-gray-600">
                  {submissions.length} réponses
                </span>
              </div>
              <div className="space-y-3">
                {[
                  { label: 'jours ouvrables', value: stats.disponibiliteJoursOuvrables },
                  { label: 'Soirs', value: stats.disponibiliteSoirs },
                  { label: 'weekend', value: stats.disponibiliteWeekend },
                ].map((item, index) => {
                  const totalSubmissions = submissions.length;
                  const percentage = totalSubmissions > 0 ? ((item.value / totalSubmissions) * 100).toFixed(1) : 0;
                  const maxCount = Math.max(
                    stats.disponibiliteJoursOuvrables || 0,
                    stats.disponibiliteSoirs || 0,
                    stats.disponibiliteWeekend || 0,
                    1
                  );
                  const barWidth = maxCount > 0 ? (item.value / maxCount * 100) : 0;
                  
                  return (
                    <div key={index} className="flex items-center gap-4">
                      <div className="w-32 text-sm font-medium text-gray-700">{item.label}</div>
                      <div className="flex-1">
                        <div className="relative w-full bg-gray-200 rounded h-8">
                          <div
                            className="bg-blue-500 h-8 rounded transition-all duration-300 flex items-center justify-end pr-3"
                            style={{ width: `${barWidth}%`, minWidth: item.value > 0 ? '60px' : '0' }}
                          >
                            {item.value > 0 && (
                              <>
                                <span className="text-white text-xs font-medium mr-2">{item.value}</span>
                                <span className="text-white text-xs font-medium">({percentage}%)</span>
                              </>
                            )}
                          </div>
                          {item.value === 0 && (
                            <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-xs">
                              0 (0%)
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
    </>
  );
}

export default StatsPanel;
